import React from "react";
import "../style/VerificationUserModal.css";

function getInitials(name) {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].charAt(0);
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0));
}

function VerificationUserModal({ show, request, onClose }) {
  if (!show || !request) return null;

  const { user, nombreCompleto, numeroIdentidad, telefono, direccion } = request;
  const displayName = nombreCompleto || user?.nombre || "Usuario";

  return (
    <div className="vum-overlay" onClick={onClose}>
      <div className="vum-container" onClick={(e) => e.stopPropagation()}>
        <button className="vum-close" onClick={onClose} aria-label="Cerrar">×</button>
        <div className="vum-header">
          <div className="vum-avatar">{getInitials(displayName)}</div>
          <div className="vum-titles">
            <h2 className="vum-title">Información del Usuario</h2>
            <p className="vum-subtitle">{displayName}</p>
          </div>
        </div>
        <div className="vum-body">
          <div className="vum-field">
            <span className="vum-label">Nombre</span>
            <span className="vum-value">{user?.nombre || "—"}</span>
          </div>
          <div className="vum-field">
            <span className="vum-label">Correo</span>
            <span className="vum-value">
              {user?.correo ? (
                <a className="vum-link" href={`mailto:${user.correo}`}>
                  {user.correo}
                </a>
              ) : (
                "—"
              )}
            </span>
          </div>
          <div className="vum-field">
            <span className="vum-label">Nombre Completo</span>
            <span className="vum-value">{nombreCompleto || "—"}</span>
          </div>
          <div className="vum-grid">
            <div className="vum-field">
              <span className="vum-label">Número de Identidad</span>
              <span className="vum-value vum-value--mono">{numeroIdentidad || "—"}</span>
            </div>
            <div className="vum-field">
              <span className="vum-label">Teléfono</span>
              <span className="vum-value vum-value--mono">
                {telefono ? (
                  <a className="vum-link" href={`tel:${telefono}`}>
                    {telefono}
                  </a>
                ) : (
                  "—"
                )}
              </span>
            </div>
          </div>
          <div className="vum-field">
            <span className="vum-label">Dirección</span>
            <span className="vum-value">{direccion || "—"}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerificationUserModal;
